import useProductDetailsHashSync from '../../hooks/useProductDetailsHashSync';
import useProductDetailsActions from '../../hooks/useProductsDetailsActions';

const ProductDetailsUrlSync = () => {
  const { handleCloseModal } = useProductDetailsActions();

  useProductDetailsHashSync({ onCloseModal: handleCloseModal });

  return null;
};

export default ProductDetailsUrlSync;
